<template>
  <el-dialog
    :title="`未匹配UDI/RFID`"
    :width="pda.status ? '90%': '1000px'" 
    :append-to-body="true"
    :visible.sync="show"
    >
    <el-table
      border
      :data="list"
      >
      <el-table-column
        type="index"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="udi"
        label="udi"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="instrument_name"
        label="绑定器械"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="instrumentset_name"
        label="绑定器械包"
        align="center"
      ></el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import { checkUdiBindOthers } from '@/api.js'
export default {
  name: 'UdiList',
  props: {
    innerCode: {
      type: String,
      default: '',
      require: true
    }
  },
  computed: {
    ...mapGetters(['exec', 'pda'])
  },
  data() {
    return {
      show: false,
      list: [],
    }
  },
  methods: {
    open(udis) {
      const list = udis.map(i => {
        return {
          udi: i,
          instrument_name: '',
          instrumentset_name: ''
        }
      })

      this.list = list
      this.checkUdis(udis)
      this.show = true
    },
    checkUdis(udis) {
      const params = {
        udi: udis
      }

      this.$request('post', checkUdiBindOthers, params)
      .then(res => {
        res.filter(i => i.inner_code !== this.innerCode).forEach(i => {
          this.list.forEach(l => {
            if (i.udi === l.udi) {
              this.$set(l, 'instrument_name', i.instrument_name)
              this.$set(l, 'instrumentset_name', i.instrumentset_name)
            }
          })
        })
      })
    },
  }
}
</script>

<style>

</style>